import { useMemo } from 'react';

import { useAuth } from '../features/auth/AuthProvider';
import { formatAbsolute, formatClock, formatPrecise, formatRelative } from './time';

/** Formatters bound to the organisation's time zone. */
export function useTimeFormat() {
  const { session } = useAuth();
  const timeZone = session?.tenant.timezone;
  return useMemo(
    () => ({
      timeZone,
      absolute: (iso: string) => formatAbsolute(iso, timeZone),
      precise: (iso: string) => formatPrecise(iso, timeZone),
      clock: (d: Date) => formatClock(d, timeZone),
      relative: (iso: string) => formatRelative(iso),
    }),
    [timeZone],
  );
}
